import { Plugin } from "@ckeditor/ckeditor5-core";

import InsertSymbolCommand from "./InsertSymbolCommand";
import { DEFAULT_SYMBOLS, INSERT_SYMBOL_COMMAND } from "./symbols";

export default class SymbolShortcutsEditing extends Plugin {
  static get pluginName() {
    return "SymbolShortcutsEditing";
  }

  // The default is defined in the constructor rather than in init() so
  // `symbolShortcuts.items` is readable by any plugin - including one that
  // initializes before this plugin - during the whole init sequence.
  constructor(editor) {
    super(editor);

    editor.config.define("symbolShortcuts", { items: DEFAULT_SYMBOLS });
  }

  init() {
    const editor = this.editor;

    // A single command serves every button - the character is passed in when
    // the command is executed.
    editor.commands.add(INSERT_SYMBOL_COMMAND, new InsertSymbolCommand(editor));

    // Track changes disables every command it does not know about, so the
    // command has to be registered explicitly. The insertion it performs is
    // then recorded as a normal insertion suggestion.
    if (editor.plugins.has("TrackChangesEditing")) {
      const trackChangesEditing = editor.plugins.get("TrackChangesEditing");
      trackChangesEditing.enableCommand(INSERT_SYMBOL_COMMAND);
    }
  }
}
